/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentContacts.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Contact API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, December 03, 2018 - 03:35:09 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      12/03/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Contacts = {
    all: () => requests.get('/Contacts'),
    get: contactid => requests.get(`/Contact/${contactid}`),
    create: contact => requests.post(`/Contacts`, contact),
    update: (contactid, contact) => requests.put(`/Contact/${contactid}`, contact),
    delete: contactid => requests.del(`/Contact/${contactid}`),
};